import axios, { AxiosError } from "axios";
import React, { useEffect, useState, ReactNode, useCallback } from "react";
import Messages from "../../config/messages.constants";
import { useToast } from "../../context/ToastContext";
import { getErrorStatus } from "../../lib/error-handling";
import LocalStorage from "src/call-sdk/lib/local-storage";
import StorageConstants from "src/config/storage.constants";

interface AxiosInterceptorsrProps {
  children: ReactNode;
}

const AxiosInterceptors: React.FC<AxiosInterceptorsrProps> = ({ children }) => {
  const toast = useToast();
  const [loading, setLoading] = useState(true);

  const handleResponseError = useCallback(
    (error: AxiosError) => {
      const status = getErrorStatus(error);

      if (status === 401) {
        toast.error(Messages.TOKEN_EXPIRED);
      }

      return Promise.reject(error);
    },
    [toast]
  );

  useEffect(() => {
    const requestInterceptorId = axios.interceptors.request.use(
      async (config) => {
      const isHUUser = Boolean(LocalStorage.get(StorageConstants.IS_HU_USER));

        config.headers["cache-control"] = `no-cache`;
        config.headers['App-Name'] = `userapp`;
        config.withCredentials = true;
        config.headers["App-Source"] = isHUUser ? "huqrapp" : "qrapp";

        return config;
      }
    );

    const responseInterceptorId = axios.interceptors.response.use(
      (response) => {
        return response;
      },
      handleResponseError
    );

    setLoading(false);

    return () => {
      axios.interceptors.request.eject(requestInterceptorId);
      axios.interceptors.response.eject(responseInterceptorId);
    };
  }, [handleResponseError]);

  if (loading) {
    return <div>Loading...</div>;
  }
  return <>{children}</>;
};

export default AxiosInterceptors;
